import script from "./editNickName.vue?vue&type=script&setup=true&name=EditNickName&lang=js"
export * from "./editNickName.vue?vue&type=script&setup=true&name=EditNickName&lang=js"

import "./editNickName.vue?vue&type=style&index=0&id=b2569d2e&scoped=true&lang=css"
import "./editNickName.vue?vue&type=style&index=1&id=b2569d2e&scoped=true&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2569d2e"]])

export default __exports__